interface ErrorResponse {
    code: number;
    message: string;
}

export interface JackpotReserveState {
    jackpotReserveData: any;
    loading: boolean;
    jackpotReservedError: ErrorResponse | null;
}


export enum JackpotReserveActionTypes {
    FETCH_JACKPOT_RESERVE_DATA = "FETCH_JACKPOT_RESERVE_DATA",
    FETCH_JACKPOT_RESERVE_DATA_SUCCESS = "FETCH_JACKPOT_RESERVE_DATA_SUCCESS",
    FETCH_JACKPOT_RESERVE_DATA_ERROR = "FETCH_JACKPOT_RESERVE_DATA_ERROR",
}

export type JackpotReserveAction =
    | { type: JackpotReserveActionTypes.FETCH_JACKPOT_RESERVE_DATA }
    | { type: JackpotReserveActionTypes.FETCH_JACKPOT_RESERVE_DATA_SUCCESS; payload: any[] }
    | { type: JackpotReserveActionTypes.FETCH_JACKPOT_RESERVE_DATA_ERROR; payload: any };